import { FormButtonBox } from "@/features/standard/Form/FormButtonBox";
import { FormMain } from "@/features/standard/Form/FormMain";
import { FormWrapper } from "@/features/standard/Form/FormWrapper";
import { Button, TextInput } from "@mantine/core";

import { SitesAutoComplete } from "@/features/ui/autoComplete/site/sites-autoComplete";

import { mutateLocations } from "@/api/locations/useLocationsQuery";
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/alert";
import { validateFormValues } from "@/utils/validation";
import { useForm } from "@mantine/form";
import { MasterApiLocationsLocationIdPutRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";

const Update = Object.assign(FormMain, {
  Button: Button,
  Input: TextInput,
  Wrapper: FormWrapper,
  ButtonBox: FormButtonBox,
});

export const LocationUpdateForm = (params: { formatterProps: any }) => {
  const { closeModal } = useModal();
  const { formatterProps } = params;
  const queryClient = useQueryClient();
  const { mutate: updateMutate } = useMutation(
    (params: MasterApiLocationsLocationIdPutRequest) =>
      mutateLocations.update(params).mutationFn(params as MasterApiLocationsLocationIdPutRequest | any),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('locations')
      }
    }
  );
  const [errorMessage, setErrorMessage] = useState<string | undefined>("");

  const form = useForm({
    initialValues: {
      code: formatterProps.code,
      name: formatterProps.name,
      siteCode: formatterProps.siteCode,
    },
  });

  const onSubmit = () => {
    try {
      updateMutate(
        {
          locationId: formatterProps.id as number,
          locationsGetRequest: {
            code: form.values.code!,
            name: form.values.name!,
            siteCode: form.values.siteCode!,
          },
        },
        {
          onSuccess: (res) => {
            closeModal(formatterProps);
            if (res.status === 200) {
              customAlert(
                "로케이션 수정에 성공하였습니다.",
                "수정 성공",
                "green"
              )
            } else {
              customAlert(
                "로케이션 수정에 실패하였습니다.",
                "수정 실패",
                "red"
              )
            }
          },
        },
      );
    } catch (e) {
      customAlert(
        "로케이션 수정에 실패하였습니다.",
        "수정 실패",
        "red"
      )
    }
  };

  return (
    <>
      <Update.Wrapper>
        <Update.Input
          label="로케이션코드"
          withAsterisk
          defaultValue={formatterProps?.code}
          {...form.getInputProps("code")}
          error={
            form.isDirty("code")
              ? "저장 필요"
              : errorMessage
                ? errorMessage
                : ""
          }
          styles={{
            input: {
              color: form.isDirty("code") ? "cadetblue !important" : "inherit",
              borderColor: form.isDirty("code")
                ? "cadetblue !important"
                : "inherit",
            },
            error: { fontSize: 11, color: "cadetblue" },
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const regex = /^[A-Za-z0-9_]*$/;
            if (regex.test(e.target.value)) {
              form.getInputProps("code").onChange(e);
              setErrorMessage(""); // 유효한 입력인 경우 에러 메시지 제거
            } else {
              setErrorMessage("한글은 입력할 수 없습니다."); // 유효하지 않은 입력인 경우 에러 메시지 설정
            }
          }}
        />
        <Update.Input
          label="로케이션이름"
          withAsterisk
          defaultValue={formatterProps?.name}
          {...form.getInputProps("name")}
          error={form.isDirty("name") ? "저장 필요" : ""}
          styles={{
            input: {
              color: form.isDirty("name") ? "cadetblue !important" : "inherit",
              borderColor: form.isDirty("name")
                ? "cadetblue !important"
                : "inherit",
            },
            error: { fontSize: 11, color: "cadetblue" },
          }}
        />
        <SitesAutoComplete
          label="사이트 코드"
          withAsterisk
          width="100%"
          defaultValue={formatterProps?.siteCode}
          {...form.getInputProps("siteCode")}
          error={form.isDirty("siteCode") ? "저장 필요" : ""}
          styles={{
            input: {
              color: form.isDirty("siteCode")
                ? "cadetblue !important"
                : "inherit",
              borderColor: form.isDirty("siteCode")
                ? "cadetblue !important"
                : "inherit",
            },
            error: { fontSize: 11, color: "cadetblue" },
          }}
        />
        <Update.ButtonBox>
          <Update.Button color="gray" onClick={closeModal}>
            취소
          </Update.Button>
          <Update.Button
            disabled={validateFormValues({
              pageType: "location",
              values: form.values,
            })}
            onClick={onSubmit}
          >
            로케이션 수정
          </Update.Button>
        </Update.ButtonBox>
      </Update.Wrapper>
    </>
  );
};
